import * as React from 'react';

export class NavbarTitle extends React.Component<{}, {}> {
  public render() {
    return <span className='navbar-title'>{this.props.children}</span>;
  }
}
